module.exports = __webpack_public_path__ + "img/marketing.72606b24.svg";